import {Step} from './Step';
import {getStepHeight} from './getStepHeight';

declare const THREE: any;

export class Stairs extends (THREE.Object3D as { new(): any; }) {

  constructor(steps: any[], stepWidth: number) {
    const position = new THREE.Vector3();
    const qt = new THREE.Quaternion();
    super();
    const yStep = 0.1;
    let currentY = 0;
    steps.forEach(step => {
      const stepHeight = getStepHeight(step);
      step.getWorldPosition(position);
      step.getWorldQuaternion(qt);
      const mesh = new Step(stepWidth, stepHeight);
      mesh.position.copy(position).setY(currentY);
      mesh.quaternion.copy(qt);
      this.add(mesh);
      currentY += yStep;
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Stairs/index.ts